import React from "react";

const Footer = () => {
  const currentYear = new Date().getFullYear();
  
  return (
    <footer className="px-6 py-4 bg-white border-t border-gray-200 relative z-40">
          <p className="text-xs text-gray-500 text-center">
            © {currentYear} Unisoft Solutions. All rights reserved.
          </p>
    </footer>
  );
};

export default Footer;
